/* Sohi — announcement bar ticker. Messages come from the section's JSON block. */
(function () {
  "use strict";

  function init(bar) {
    if (bar.dataset.sohiReady === "true") return;
    bar.dataset.sohiReady = "true";

    var out = bar.querySelector("[data-ticker-out]");
    var data = bar.querySelector("[data-ticker-data]");
    if (!out || !data) return;

    var messages;
    try {
      messages = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(messages) || messages.length < 2) return;

    var idx = 0;
    var timer = null;

    function show(n) {
      idx = (n + messages.length) % messages.length;
      out.textContent = messages[idx];
    }

    bar.querySelectorAll("[data-ticker]").forEach(function (b) {
      b.addEventListener("click", function () {
        show(idx + (b.dataset.ticker === "next" ? 1 : -1));
        if (timer) { clearInterval(timer); timer = null; }
      });
    });

    var seconds = parseFloat(bar.dataset.rotate);
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (seconds > 0 && !reduced) {
      timer = setInterval(function () { show(idx + 1); }, seconds * 1000);
    }
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-announcement]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
